const manual_en = {
  title: 'Manual',
  loading: 'Loading the manual…',
  error: {
    title: 'The manual is currently unavailable',
    description:
      'We could not load the help site right now. Please try again in a moment or open it in a new tab.',
    retry: 'Try again',
  },
  external: {
    title: 'The manual opens in a new tab',
    description:
      'Our help site cannot currently be displayed inside ExhibitorHub. You will find the full manual as well as tips & tricks at help.la-concept.de.',
    action: 'Open the manual',
  },
  openInNewTab: 'Open in a new tab',
}

export default manual_en
